















































import { Vue, Prop, Component } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CheckedUsersForInviteItem from "@/components/invite-users/CheckedUsersForInviteItem.vue";
import api from "@/getinfo-api";
import { UserInvite as IUserInvite } from "@/api/models/user-invite";

@Component({
  components: {
    CustomTable,
    CustomButton,
    CheckedUsersForInviteItem
  }
})
export default class CheckedUsersForInvite extends Vue {
  @Prop() users?: Array<IUser>;
  @Prop() userIds?: Array<string>;
  isShowTable: boolean = false;
  usersList: Array<IUser> = this.users ? this.users : [];
  selected: Array<IUser> = [];
  isInviteProcessing: boolean = false;

  openTable() {
    this.isShowTable = !this.isShowTable;
  }

  check(user: IUser) {
    return this.selected?.includes(user);
  }

  addUser(user: IUser) {
    if (this.selected.includes(user)) {
      this.selected = this.selected?.filter(el => el !== user);
    } else {
      this.selected.push(user);
    }
  }

  addAllUsers(checked: boolean) {
    this.selected = checked ? this.usersList.slice() : [];
  }

  get indeterminate() {
    return (
      this.selected.length > 0 && this.selected.length !== this.users?.length
    );
  }

  get isAllUsersChecked() {
    return this.usersList.length === this.selected.length;
  }

  async userInvite() {
    if (this.selected.length) {
      this.isInviteProcessing = true;
      try {
        let array: Array<IUserInvite> = this.selected.map(el => {
          let params: IUserInvite = {
            email: el.email
          };
          return params;
        });
        await api.UsersApi.invite(array);
        await this.$store.dispatch("successToast", {
          message: this.$tc(this.$translate.InvitationsHaveBeenSuccessfullySent)
        });
      } catch (err) {
        await this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      } finally {
        this.isInviteProcessing = false;
      }
    }
  }
}
